import DisplayFilesByLeadCategory from './DisplayFilesByLeadCategory.component';

export default DisplayFilesByLeadCategory;
